/* eslint-disable */
import {Table, Tag, Space} from "antd"
import "antd/lib/pagination/style/index.css"
import "antd/lib/space/style/index.css"
import "antd/lib/table/style/index.css"
import "antd/lib/tag/style/index.css"
import React from "react"
import styled from "styled-components"

const Calculations = (props) => {
  return (
    <OuterDiv>
      <Table columns={props.columns} dataSource={props.data} rowKey="id" />
    </OuterDiv>
  )
}

const OuterDiv = styled.div``

Calculations.defaultProps = {
  data: [
    {
      id: "1",
      calculationType: "Assignment",
      calculationUrl: "https://www.pwc.com/calculation-full-output",
      companyName: "Hastings Pharmaceutical",
      employeeId: "dollywood001",
      endDate: "31-Dec-2022",
      firstName: "Dolly",
      homeCountry: "United Kingdom",
      hostCountry: "California - United States",
      lastName: "Parton",
      startDate: "01-Jan-2020",
      taxCountry: null,
      taxYear: null,
    },
    {
      id: "2",
      calculationType: "Transfer",
      calculationUrl: "https://www.pwc.com/calculation-full-output",
      companyName: "Hastings Pharmaceutical",
      employeeId: "jglyne001",
      endDate: "31-Dec-2021",
      firstName: "Jess",
      homeCountry: "United Kingdom",
      hostCountry: "Brazil",
      lastName: "Glyne",
      startDate: "01-Jan-2020",
      taxCountry: null,
      taxYear: null,
    },
    {
      id: "3",
      calculationType: "Annual Tax",
      calculationUrl: "https://www.pwc.com/calculation-full-output",
      companyName: "Hastings Pharmaceutical",
      employeeId: "dollywood001",
      endDate: null,
      firstName: "Dolly",
      homeCountry: null,
      hostCountry: null,
      lastName: "Parton",
      startDate: null,
      taxCountry: "United States",
      taxYear: 2020,
    },
  ],
  columns: [
    {
      title: "Assignee",
      key: "lastName",
      dataIndex: "lastName",
      render: (lastName, rest) => {
        return `${lastName}, ${rest.firstName}`
      },
    },
    {
      title: "Calculation type",
      key: "calculationType",
      dataIndex: "calculationType",
      render: (calculationType) => {
        return (
          <Tag color={prepareTagColor(calculationType)}>
            {calculationType.toUpperCase()}
          </Tag>
        )
      },
    },
    {
      title: "Host country",
      dataIndex: "hostCountry",
      key: "hostCountry",
    },
    {
      title: "Tax country",
      dataIndex: "taxCountry",
      key: "taxCountry",
    },
    {
      title: "Tax year",
      dataIndex: "taxYear",
      key: "taxYear",
    },
    {
      title: "Start date",
      dataIndex: "startDate",
      key: "startDate",
    },
    {
      title: "End date",
      dataIndex: "endDate",
      key: "endDate",
    },
  ],
}

function prepareTagColor(calculationType) {
  switch (calculationType) {
    case "Annual Tax":
      return "magenta"
    case "Transfer":
      return "orange"
    default:
      return "blue"
  }
}

export {Calculations}
